import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useCrmBreakpoint } from "../hooks/useCrmBreakpoint";

export default function Drawer({ open, onClose, width = 480, fullScreenOnMobile = true, children }) {
  const { isMobile } = useCrmBreakpoint();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  const mobileFull = fullScreenOnMobile && isMobile;
  const panelWidth = mobileFull ? "100vw" : width;
  const panelMaxWidth = mobileFull ? "100vw" : "calc(100vw - 48px)";

  return (
    <AnimatePresence>
      {open && (
        <React.Fragment key="crm-drawer">
          <motion.div
            key="crm-drawer-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.22, ease: "easeOut" }}
            onClick={onClose}
            style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(8,10,18,0.5)", backdropFilter: "blur(3px)" }}
          />
          <motion.aside
            key="crm-drawer-panel"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", ease: [0.32, 0.72, 0, 1], duration: 0.32 }}
            style={{
              width: panelWidth,
              maxWidth: panelMaxWidth,
              height: "100%",
              // 2026-08-30: the panel itself paints its surface. `.crm-shell`
              // only DECLARES the palette vars (index.css) — it never sets a
              // background — so a drawer whose content didn't paint one showed
              // the page through it. Resolved on this element, both themes.
              background: "var(--color-bg-base)",
              color: "var(--color-text-primary)",
              borderLeft: "1px solid var(--color-border-subtle)",
              boxShadow: mobileFull ? "none" : "-12px 0 40px rgba(0,0,0,0.16)",
            }}
            className="crm-shell fixed right-0 top-0 bottom-0 z-[1001] flex flex-col min-h-0 overflow-hidden"
          >
            {children}
          </motion.aside>
        </React.Fragment>
      )}
    </AnimatePresence>
  );
}
